// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductBuyerHeader":"cz_a bhj_sp","ProductBuyerHeader__username":"cz_b bhj_vf"};